import React                   from 'react';
import { dataCode as tooltip } from 'pu-data/Tooltips';
import CheckboxComponent       from './CheckboxComponent';

const DataCode = (props) => {
  const name = 'lot_code';
  const { parameters } = props
  return (
    <div className="form-group">
      <CheckboxComponent
        name={name}
        inputId={name}
        label="Date Code"
        groupName={props.groupName}
        tooltip={props.tooltip}
        checked={parameters[name] === '1'}
        onChange={e => props.onChangeParameter(name, e.target.checked ? '1' : '0')} />
    </div>
  );
};

DataCode.defaultProps = {
  tooltip,
};

export default DataCode;
